import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import '../css/login-modal.css';
import Input from './Input';
import { showNotification } from '../utils/NotificationUtils';

const LoginModal = ({ handleLogin, isModal = true }) => {

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');


  const login = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}token`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username: username,
          password: password
        }),
      });

      const data = await response?.json();

      if (response.ok) {
        // Armazenando o token no localStorage
        localStorage.setItem('access_token', data.access_token);
        handleLogin(data.access_token);
        window.location.reload();
      } else {
        if (401 == response?.status) {
          showNotification('Usuário ou senha inválidos', 'error')
        }
      }
    } catch (error) {
      showNotification('Erro ao realizar login ', 'error')
    }
  };

  return (
    <div className={"login-modal-container"}>

      <div id="notification-container" className='notification-container' style={{
        position: "fixed",
        display: "flex,",
        flexDirection: "column-reverse",
        justifyContent: "flex-end",
        flexWrap: "wrap-reverse",
        alignItems: "flex-end",
        bottom: "0,",
        right: "30px",
        maxHeight: "100vh"
      }}></div>

      <div className="login-box">
        <h1 style={{ color: '#5E5E5E' }}>Login</h1>
        <form onSubmit={(e) => e.preventDefault()}>
          {/* <div className='row'>
            <Input id="username" value={username} parameters={{width: '100%', type:'text', label:"Usuário", onChange: (value) => setUsername(value)}}/>
          </div>
          <div className='row'>
            <Input id="password" value={password} type="password" parameters={{type:"password", width: '100%', label:"Senha", onChange: (value) => setPassword(value)}}/>
          </div> */}

          <div className="input-group-login">
            <i className="fas fa-user"></i>
            <input type="text" placeholder="Usuário" onChange={(e) => setUsername(e.target.value)} />
          </div>
          <div className="input-group-login">
            <i className="fas fa-lock"></i>
            <input type="password" placeholder="Senha" onChange={(e) => setPassword(e.target.value)} />
          </div>

          <button className="button" type="submit" onClick={login}>Login</button>

          <div className='row'>
            <span style={{ color: 'red' }}>Sua sessão expirou, realize login para continuar utilizando o sistema.</span>
          </div>

        </form>
      </div>
    </div>
  );
};

export default LoginModal;
